import script from "./OpeningHoursItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpeningHoursItem.vue?vue&type=script&setup=true&lang=ts"

import "./OpeningHoursItem.vue?vue&type=style&index=0&id=b9e47abc&lang=scss"

const __exports__ = script;

export default __exports__